<style scoped>
.margin-l-r {
    margin: 0 10px;
}
</style>
<template>
  <div>
    <div class="line text-center">
      <Select
        v-model="params.status"
        class="margin-l-r"
        placeholder="选择完成类型"
        style="width: 120px"
        @on-change="doSearch"
      >
        <Option :value="4">
          所有类型
        </Option>
        <Option :value="0">
          未完成
        </Option>
        <Option :value="1">
          已完成
        </Option>
        <Option :value="2">
          HOLD
        </Option>
        <Option :value="3">
          已废弃
        </Option>
      </Select>
      <div class="search-input">
        <i-input
          v-model="params.search"
          class="margin-l-r"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        class="margin-l-r"
        :url="$util.api.query_file_stamp"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
      <div style="display: inline-block;">
        <Button 
          type="primary"
          @click="exportExcel"
        >
          导出归档登记
        </Button>
      </div>
    </div>

    <Table
      size="small"
      :columns="columns"
      :data="file_stamps"
      :loading="loading"
    />

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <HoldModal
      :display="h_modal"
      :form-props="h_select_data"
      :loading="h_loading"
      @cancel="h_modal=0"
      @ok="holdAnddiscard"
    />
    <UploadingModal
      :display="h_modal"
      :form-props="h_select_data"
      :loading="up_loading"
      @ok="uploadingFun"
      @cancel="h_modal=0"
    />
    <ExportModal 
      ref="export-modal"
    />
  </div>
</template>
<script route="/file_stamp/list">
  import ViewerItem from '../components/viewer/item';
  import HoldModal from './components/HoldModal'
  import UploadingModal from './components/UploadingModal'
  import Attachments from './../components/file/attachments'
  import ExportModal from './components/ExportModal'
  import {mapGetters} from "vuex";
  //  './../../components/file/edit_attachments'
  const item_hash = {
    0:'未完成',
    1:'已完成',
    2:'HOLD',
    3:'已废弃'
  }
  export default {
    components: { ViewerItem, HoldModal, UploadingModal, Attachments, ExportModal },
    data() {
      return {
        loading: false,
        up_loading:false,
        h_loading: false,
        h_modal: 0,
        h_select_data: null,
        params: {
          search: '',
          per_page: 20,
          page: 1,
          status: 4
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        file_stamps: [],
        columns: [

          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 40,
            render: (h, params) => {
              const row = params.row
              if (row.bfiles && row.bfiles.length) {
                return (<div> 附件：
                                    <div style="display:inline-block">
                                        <Attachments files={row.bfiles}/>
                                    </div>
                                </div>)
              }
              return h('div', '无附件')
            }
          },

          {
            title: '申请人',
            width: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return <CustomerName id={ row.customer_id } />
            }
          },
          {
            title: '团队',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const team = this.teams_hash[row.team_id];
              return h('span', team ? team.full_name : '-');
            }
          },
          {
            title: '文件标示',
            align: 'center',
            minWidth: 160,
            render: (h, params) => {
              const row = params.row;
              const item = row.file_stamp_items[0];
              const remark = '-';
              switch (item.file_type) {
              case 'contract':
                return h(ViewerItem, {
                  props: {
                    type: 'Contract',
                    model_id: item.contract_id
                  },
                  'class': {
                    link: true
                  }
                }, [
                  h('div', item.contract.uid),
                  h('div', item.contract.name),
                ]);
              case 'outsource-contract':
                return h(ViewerItem, {
                  props: {
                    type: 'OutsourceContract',
                    model_id: item.contract_id
                  },
                  'class': {
                    link: true
                  }
                }, [
                  h('div', item.contract.uid),
                  h('div', item.contract.account),
                ]);
              case 'hr-file':
                return h('span', '-');
              case 'other':
                return h('span', item.file_type_other);
              default:
                break;
              }
              return h('span', remark);
            }
          },
          {
            title: '文件类型',
            minWidth: 80,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const item = row.file_stamp_items[0];
              let type = '未定义类型';
              switch (item.file_type) {
              case 'contract':
                type = '合同';
                break;
              case 'outsource-contract':
                type = '云账户合同';
                break;
              case 'hr-file':
                type = '劳动合同/解除协议';
                break;
              case 'other':
                type = '其他';
                break;
              default:
                break;
              }
              return h('span', type);
            }
          },
          {
            title: '处理(份数)',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const item = row.file_stamp_items[0];
              const stamp_count = item.stamp_count === -1 ? '4+' : item.stamp_count;
              const archive_count = item.archive_count === -1 ? '4+' : item.archive_count;
              const type = item.handle_type.replace('stamp', `盖章(${stamp_count})`).replace('archive', `归档(${archive_count})`).replace(',', '/');
              return h('span', type);
            }
          },
          {
            title: '盖章公司',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const item = row.file_stamp_items[0];
              const company = this.companies_hash[item.company_id];
              return h('span', company ? company.short_name : '');
            }
          },
          {
            title: '备注',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const item = row.file_stamp_items[0];
              return h('span', item.remark || '-');
            }
          },
          {
            title: '审批人备注',
            minWidth: 120,
            align: 'center',
            key: 'examine_remark'
          },
          {
            title: '完成员工',
            minWidth: 80,
            align: 'center',
            render: (h, params) => {
              const user_id = params.row.finish_user_id;
              return user_id ? <CustomerName id={ user_id } /> : h('span', '-');
            }
          },
          {
            title: '使用时长（小时）',
            minWidth: 120,
            align: 'center',
            render: (h, params) => {
              const finished_at = params.row.finished_at;
              const created_at = params.row.created_at;
              // created_at
              return h('span', (!finished_at || !created_at) ? '-' : moment(finished_at).diff(moment(created_at), 'hour'))
            }
          },
          {
            title: '登记时间',
            minWidth: 130,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatTime(row.created_at));
            }
          },
          {
            title: '完成状态',
            width: 80,
            align: 'center',
            fixed: 'right',
            render: (h, params) => {
              const row = params.row;
              if ([1, 3].includes(row.status)) {
                return h('span', {
                  class: {
                    'color-success': row.status === 1,
                    'color-disabled': row.status === 3,
                  }
                }, item_hash[row.status]);
              }

              return h('div', {
                style: {
                  position: 'relative'
                }
              }, [
                h('Spin', {
                  props: {
                    size:"small",
                    fix: true
                  },
                  style: {
                    display: row._loading ? 'block' : 'none'
                  }
                }),
                h('Dropdown',
                  {
                    'on': {
                      'on-click':(value) => {
                        this.changeType(value, row)
                      }
                    },
                    props: {
                      trigger: 'click'
                    }
                  }, [
                    h('a', {
                      href:"javascript:void(0)"
                    }, item_hash[row.status]),
                    h('DropdownMenu', {
                      slot: 'list'
                    }, [
                      h('DropdownItem', {
                        props: {
                          name:1,
                          disabled: 1 === row.status
                        }
                      }, '完成'),
                      h('DropdownItem', {
                        props: {
                          name:2,
                          disabled: 2 === row.status
                        }
                      }, 'HOLD'),
                      h('DropdownItem', {
                        props: {
                          name:3,
                          disabled: 3 === row.status
                        }
                      }, '废弃')
                    ])
                  ])
              ])
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              if (row.status === 1) {
                return h('Button', {
                  props: {
                    size:'small',
                    type:'primary'
                  },
                  on: {
                    click:() => {
                      this.h_modal = 1
                      this.h_select_data = row
                    }
                  }
                }, '附件/备注')
              }
              return <span>-</span>;
            }
          },

        ]
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      exportExcel() {
        this.$refs['export-modal'].show()
      },
      changeType(val, row) {
        if ([2, 3].includes(val)) {
          this.h_modal = val
          this.h_select_data = row
          return
        }
        this.$Modal.confirm({
          title: '提示',
          content:'确认完成？',
          onOk: () => {
            this.$set(row, '_loading', true)
            this.$util.ajax.post(this.$util.api.update_status_file_stamp, {
              id: row.id,
              status: 1,
              examine_remark: row.examine_remark
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                const { file_stamp } = res.data;
                this.file_stamps.updateOrPush(file_stamp);
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            }).finally(() => {
              row._loading = false
            });
          }
        })
      },
      holdAnddiscard({call, ...other}) {

        this.$util.ajax.post(this.$util.api.update_status_file_stamp, other).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.h_select_data.status = other.status;
            this.h_select_data.examine_remark = other.examine_remark
            this.h_modal = 0
            this.h_select_data = null
            const { file_stamp } = res.data;
            this.file_stamps.updateOrPush(file_stamp);
            call()
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.h_loading = false
        });
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
      },
      handleData(data) {
        this.loading = false;
        this.file_stamps = data.file_stamps;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.$Modal.error({title: '提示', content: e.message});
      },
      uploadingFun({call, ...data}) {
        this.up_loading = true
        this.$util.ajax.post(this.$util.api.file_stamp_add_accessory, data).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            Object.keys(this.h_select_data).forEach((key) => {
              this.h_select_data[key] = res.data.file_stamp[key] || this.h_select_data[key]
            })
            call()
            this.$Message.success('已成功备注/上传附件')
            this.h_modal = 0
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.up_loading = false
        });
      }
    }
  }
</script>
